import React from 'react';

interface Props {
  height?: number;
  message?: string;
}

// Forward-only data means early periods are legitimately empty — show a calm
// placeholder rather than a broken/blank chart.
const ChartEmptyState = ({ height = 220, message = 'No data for this period yet' }: Props) => (
  <div className="flex items-center justify-center text-sm text-gray-400" style={{ height }}>
    {message}
  </div>
);

export default ChartEmptyState;
